import { cn } from "@/lib/utils/global-utils";
import React from "react";

interface CustomHorizontalListItemProps
  extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode;
  text: string;
}

const CustomHorizontalListItem = React.forwardRef<
  HTMLDivElement,
  CustomHorizontalListItemProps
>(({ icon, text, className, ...rest }, ref) => {
  return (
    <div
      className={cn(
        "flex gap-2 items-center text-base font-normal leading-md",
        className
      )}
      {...rest}
      ref={ref}
    >
      <span aria-hidden="true">{icon}</span>
      <p>{text}</p>
    </div>
  );
});

export default CustomHorizontalListItem;
